<div class="container">
  <div class="title-container">
    <div style="display: flex;">
      <h1>{{title}}</h1>
      <mat-icon class="check-icon">check_circle</mat-icon>
    </div>
    <div>
      <button class="button-Primary edit-btn" (click)="navigateToEdit()">Edit</button>
    </div>
  </div>

  <div class="section">
    <ng-content></ng-content>
  </div>
</div>